"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlModalOverlay = void 0;
var _react = require("react");
var _bem = require("./bem");
var _bero = require("bero");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Modal Overlay Component
 *
 * @description
 * Show a grayed out background
 *
 */
var GlModalOverlayCore = function GlModalOverlayCore(_ref) {
  var onClick = _ref.onClick,
    overlayClassName = _ref.overlayClassName,
    onTouchMove = _ref.onTouchMove;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    className: (0, _bero.join)((0, _bem.bemModal)('overlay'), overlayClassName),
    onClick: onClick,
    onTouchMove: onTouchMove,
    "aria-hidden": "true",
    tabIndex: -1
  });
};
var GlModalOverlay = exports.GlModalOverlay = /*#__PURE__*/(0, _react.memo)(GlModalOverlayCore);